module.exports = __webpack_public_path__ + "img/qr-chi.4056463e.png";